import { useTranslation } from 'react-i18next';
import React from 'react';
void React;
import publicHomepageContent from '../../content/publicHomepageContent';

function BrandCard({ brand }) {
  return (
    <div className="kr-model-card">
      {brand.logo ? <img src={brand.logo} alt="" className="kr-model-logo" aria-hidden="true" /> : null}
      <div className="kr-model-body">
        <div className="kr-model-name">{brand.name}</div>
        {/* intentionally no partner label to avoid implying partnership */}
      </div>
    </div>
  );
}

// linter hint
void BrandCard;

export default function RobotModelsSection() {
  const { t } = useTranslation();
  const { modelsSection } = t('homepageContent', { returnObjects: true, defaultValue: publicHomepageContent });
  // Group Belrobotics models under one brand listing and render a calm list
  const belrobotics = modelsSection.brands.filter(b => b.key === 'belrobotics')[0];
  const belModels = modelsSection.brands.filter(b => b.key && b.key.startsWith('bel-'));
  const otherBrands = modelsSection.brands.filter(b => b.key !== 'belrobotics' && !b.key.startsWith('bel-'));
  return (
    <section className="kr-section kr-models-section" aria-labelledby="models-heading">
      <div className="kr-shell">
        <div className="kr-section-head">
          <h2 id="models-heading" className="k-h2">{modelsSection.title}</h2>
          <p className="k-body">{modelsSection.intro}</p>
        </div>
        <div className="kr-models-grid">
          {belrobotics && (
            <div className="kr-model-brand">
              {belrobotics.logo && <img src={belrobotics.logo} alt="Belrobotics" className="kr-model-logo" aria-hidden="true" />}
              <div className="kr-model-list">
                <ul>
                  {belModels.map(m => (
                    <li key={m.key} className="kr-model-name">{m.name}</li>
                  ))}
                </ul>
              </div>
            </div>
          )}
          {otherBrands.map((b) => (
            <BrandCard key={b.key} brand={b} />
          ))}
        </div>
      </div>
    </section>
  );
}
